

export class PartDetailsInfoModel{
    mpn              : string;
    mfr              : string;
    qty              : number;
    dcRestrictions   : string;
    roHS             : string;
    conditions       : string;
    needDate         : string;
    cpn              : string;
    nsn              : string;
    revisions        : string;
    description      : string;
    itemPackaging    : string;
    coo              : string;
    customerTargetPrice: number;
    testing           : string;
    urgency           : string;
    targetBuyPrice    : number;
    spq               : string;
    moq               : string;
    hts               : string;
    scheduleB         :string;
    eccn              : string;
    categories        : string;
    tempRange         : string;
    partStatus        :string;
    isProjectApproved : any;
    estStartDate      : string;
    bidDeadline       : string;
    endCustomer       : string;
    projectName       : string;
    closeProbability  : number;
    application       : string;
    opportunityNotes  :string;
    type              : string;
    opportunityTypeId : number;

}

export class AddRequirementModel{
    requirementInfo         = new  RequirementInfo();
    requirementDetails      = new  RequirementDetails();
    requirementParts        = new  RequirementParts();
    opportunityDetails      = new  OpportunityDetails();
    requirementFulfillment  = new  FulfillmentDetails();
    additionalQuantities : QuantityItem[] = [];
    isDraft               : boolean = false;
}

export class RequirementInfo {
  id                   : string = "";
  requirementNo        : number;
  requirementDate      : string;
  companyId            : string = "";
  contactId            : string;
  requirementSourceId    : string;
  requirementStatus?    : string;
  customerRFQ          : string;
  currency             : string;
  customerNotes        : string;
  salesPersonId         : string;
  priorityId             : string;
  isInHouseRequirement : boolean = false;
}
export class RequirementDetails {
    id                 : string = "";
    requirementId      : string;
    mpnId              : string;
    mfrId              : string;
    qty                : number;
    dcRestrictions     : string;
    rohsId             : string;
    conditionId        : string;
    needDate           : any;
    customerPN         : string;
    nsn                : string;
    revision           : string;
    description        : string;
    itemPkgId          : string;
    cooId              : string;
    customerTargetPrice: number;
    testingId          : string;
    urgency            : string;
    targetBuyPrice     : number;
    dateCodeYearId     : string;
    dateCodeWeekId     : string;
    currencyId         : string;
    convertedTargetPrice : number;
    exchangeRate         : string;

  }
  export class RequirementParts {
    id                 : string = "";
    requirementId      : string;
    spq                : string;
    moq                : string;
    hts                : string;
    scheduleB          : string;
    eccn               : string;
    categories         : string;
    tempRange          : string;
    partStatusId       : string;
    categoryGroupId    : string;
    parentCategoryId   : string;
    categoryId         : string;
    subCategoryId      : string;
  }
  export class OpportunityDetails {
    id                 : string = "";
    requirementId      : string;
    isProjectApproved  : boolean = true;
    estStartDate       : any;
    bidDeadline        : any;
    endCustomer        : string;
    projectName        : string;
    closeProbability   : number = 0;
    application        : string;
    opportunityNotes   : string;
    opportunityTypeId    : number = 2;
    typeId               : DropdownModel[]  = [];
  }
  export class DropdownModel {
    id: string;
    name: string;
    colorCode: string;
    labelName: string;
    isActive: boolean = false;
  }
export class FulfillmentDetails {
  id: string = '';
  requirementId: string = '';
  manufacturerCOC: boolean = false;
  companyCOC : boolean = false;
  requiredImages: boolean = false;
  requiredInspectionReport: boolean = false;
}
export class QuantityItem {
  requirementId: string = '';
  requirementDetailId: string = '';
  quantity: number = 0;
} 
export class OfferDetailsModel {
  id: string = '';
  offerId: string = '';
  mpnId: string = '';
  mfrId: string = '';
  dateCodeYearId: string = '';
  dateCodeWeekId: string = '';
  rohsId: any ;
  nsn: string = '';
  conditionId: string = '';
  itemPackagingId: string = '';
  cooId: any ;
  description : string = '';
  revisions : string = '';
  lot : string = '';
  vendorLeadTime : string = '';
  warranty : string = '';
} 
